/* ====== Config ====== */
const desktop_nav_starts_at = 1024; // in pixels
console.log('core loaded');

/* ====== Tiny utilities (jQuery stand-ins) ====== */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));

function on(el, type, selectorOrHandler, maybeHandler) {
    // Supports: on(el, 'click', handler)  OR  on(el, 'click', 'a.sel', (e, target) => {})
    if (typeof selectorOrHandler === 'function') {
        el.addEventListener(type, selectorOrHandler);
        return;
    }
    const selector = selectorOrHandler;
    const handler = maybeHandler;
    el.addEventListener(type, (e) => {
        const target = e.target.closest(selector);
        if (target && el.contains(target)) handler(e, target);
    });
}

const hasClass = (el, c) => el.classList.contains(c);
const addClass = (el, ...c) => el.classList.add(...c);
const removeClass = (el, ...c) => el.classList.remove(...c);
const toggleClass = (el, c) => el.classList.toggle(c);

function fadeIn(el, duration = 200) {
    el.style.opacity = 0;
    el.style.display = '';
    const start = performance.now();

    function step(now) {
        const p = Math.min((now - start) / duration, 1);
        el.style.opacity = p.toString();
        el.style.display = 'block';
        if (p < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
}

function isOverflowing(el) {
    return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
}

function fadeOut(el, duration = 200, after) {
    const start = performance.now();
    const startOpacity = parseFloat(getComputedStyle(el).opacity) || 1;

    function step(now) {
        const p = Math.min((now - start) / duration, 1);
        el.style.opacity = (startOpacity * (1 - p)).toString();
        if (p < 1) requestAnimationFrame(step);
        else {
            el.style.display = 'none';
            if (typeof after === 'function') after.call(el);
        }
    }

    requestAnimationFrame(step);
}

function slideDown(el, duration = 200) {
    el.style.removeProperty('display');
    let display = getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    const height = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.height = '0px';
    const start = performance.now();

    function step(now) {
        const p = Math.min((now - start) / duration, 1);
        el.style.height = `${height * p}px`;
        if (p < 1) requestAnimationFrame(step);
        else {
            el.style.removeProperty('height');
            el.style.removeProperty('overflow');
        }
    }

    requestAnimationFrame(step);
}

function slideUp(el, duration = 200, after) {
    const height = el.scrollHeight;
    el.style.overflow = 'hidden';
    const start = performance.now();

    function step(now) {
        const p = Math.min((now - start) / duration, 1);
        el.style.height = `${height * (1 - p)}px`;
        if (p < 1) requestAnimationFrame(step);
        else {
            el.style.display = 'none';
            el.style.removeProperty('height');
            el.style.removeProperty('overflow');
            if (typeof after === 'function') after.call(el);
        }
    }

    requestAnimationFrame(step);
}

function getOffsetTop(el) {
    const rect = el.getBoundingClientRect();
    return rect.top + window.pageYOffset;
}

/* ====== Core ====== */
document.addEventListener('DOMContentLoaded', () => {

    /*** Resize Handler ***/
    window.addEventListener('resize', () => {
        if (window.innerWidth >= desktop_nav_starts_at) {
            hideMobileNav();
        }
    });

    /*** Hamburger / Mobile Nav ***/
    function showMobileNav() {
        const hc = $('.hamburger_container');
        if (!hc) return;
        const h = hc.querySelector('.hamburger');
        if (h) addClass(h, 'active');
        $$('.main_nav', document).forEach(nav => addClass(nav, 'open'));
        addClass(document.documentElement, 'noscroll');
    }

    function hideMobileNav() {
        const hc = $('.hamburger_container');
        if (hc) {
            const h = hc.querySelector('.hamburger');
            if (h) removeClass(h, 'active');
        }
        $$('nav.main_nav').forEach(nav => removeClass(nav, 'open'));
        removeClass(document.documentElement, 'noscroll');
    }

    on(document, 'click', '.hamburger_container', () => {
        const open = $('nav.main_nav')?.classList.contains('open');
        if (open) hideMobileNav(); else showMobileNav();
    });

    /*** Number Plate Search Input ***/
    on(document, 'change', 'input.number_plate_input', (e, target) => {
        removeInvalidCharactersFromNumberPlateInput(target);
    });
    on(document, 'input', 'input.number_plate_input', (e, target) => {
        removeInvalidCharactersFromNumberPlateInput(target);
    });

    /*** Mobile Search ***/
    on(document, 'click', 'nav.button_links a.search', (e) => {
        e.preventDefault();
        const outer = $('.header_search_form_outer');
        if (outer) {
            addClass(outer, 'active');
            const inp = outer.querySelector('input[name="search"]');
            inp?.focus();
        }
    });
    on(document, 'click', '.header_search_form_outer', (e, target) => {
        const inner = target.querySelector('.header_search_form');
        const clickedInsideInner = e.target === inner || (e.target instanceof Element && !!e.target.closest('.header_search_form'));
        if (!clickedInsideInner) removeClass(target, 'active');
    });

    /*** Sub Navigation ***/
    function showSubNav(navigation_item) {
        hideSubNav();
        const li = navigation_item.closest('li');
        const subnav = li?.querySelector('.subnav');
        addClass(navigation_item, 'active');
        if (subnav) addClass(subnav, 'active');
    }

    function hideSubNav() {
        $$('nav.main_nav > ul > li > a').forEach(a => {
            removeClass(a, 'active', 'faded');
        });
        $$('nav.main_nav > ul > li .subnav').forEach(s => removeClass(s, 'active'));
    }

    $$('nav.main_nav > ul > li .subnav').forEach(sn => {
        const li = sn.closest('li');
        if (li) addClass(li, 'has_subnav');
    });

    on(document, 'click', 'nav.main_nav > ul > li.has_subnav > a', (e, a) => {
        e.preventDefault();
        if (!hasClass(a, 'active')) showSubNav(a);
        else hideSubNav();
    });

    /*** Hide nav/subnav when clicking off ***/
    document.body.addEventListener('click', (e) => {
        const t = e.target;
        if (!(t instanceof Element)) return;

        if (
            $('.subnav.active') &&
            !t.matches('.subnav') &&
            !t.closest('.subnav') &&
            !t.closest('.modal') &&
            !t.matches('.has_subnav') &&
            !t.closest('.has_subnav')
        ) {
            hideSubNav();
        }

        const mainNavOpen = $('nav.main_nav')?.classList.contains('open');
        if (
            mainNavOpen &&
            !t.matches('nav.main_nav') &&
            !t.closest('nav.main_nav') &&
            !t.closest('.modal') &&
            !t.closest('.hamburger_container')
        ) {
            hideMobileNav();
        }
    });

    /*** Modal Handling ***/
    on(document, 'click', '[data-show-modal-on-click]', (e, target) => {
        e.preventDefault();
        showModal(target.getAttribute('data-show-modal-on-click'));
    });

    on(document, 'click', '[data-dynamic-modal-content]', (e, target) => {
        showDynamicModal(target.getAttribute('data-dynamic-modal-content'),target.getAttribute('data-dynamic-modal-title'));
    });

    on(document, 'click', '.modal .close_button, .modal_close_button, .modal_inner', (e) => {
        const isClose = (e.target instanceof Element) && (e.target.matches('.modal_inner') || e.target.matches('.close_button') || e.target.matches('.modal_close_button'));
        if (isClose) hideModal();
    });

    /*** YouTube Video Link ***/
    on(document, 'click', 'a.youtube', (e, a) => {
        e.preventDefault();
        const youtube_url = a.getAttribute('href') || '';
        const pattern = /(youtu.*be.*)\/(watch\?v=|embed\/|v|shorts|)(.*?((?=[&#?])|$))/;
        const match = youtube_url.match(pattern);
        const youtube_id = match ? match[3] : '';
        const embed_url = `https://www.youtube.com/embed/${youtube_id}?modestbranding=1&rel=0&autoplay=1`;
        const html = `<iframe class="youtube" allow="autoplay;encrypted-media" allowfullscreen src="${embed_url}"></iframe>`;
        showDynamicModal(html, 'Video','youtube');
    });

    /*** VAT and Fees Switch ***/
    on(document, 'change', 'input[name="inc_vat_and_fees"]', (e, input) => {
        if (input.checked) {
            console.log('Logic to add AJAX call / cookie set to go here.');
            $$('input[name="inc_vat_and_fees"]').forEach(i => (i.checked = true));
            $$('.inc_vat_and_fees_text').forEach(el => (el.innerHTML = 'Show inc. VAT &amp; DVLA Fee'));
            addClass(document.documentElement, 'inc_vat_and_fees');
        } else {
            $$('input[name="inc_vat_and_fees"]').forEach(i => (i.checked = false));
            $$('.inc_vat_and_fees_text').forEach(el => (el.innerHTML = 'Show ex. VAT &amp; DVLA Fee'));
            removeClass(document.documentElement, 'inc_vat_and_fees');
        }
    });
    //trigger change on the first one
    (() => {
        const first = $('input[name="inc_vat_and_fees"]');
        if (first) first.dispatchEvent(new Event('change', {bubbles: true}));
    })();

    /*** tabs ***/
    $$('.tabs_container').forEach((container) => {
        const tabs = $$('.tabs li', container);
        tabs.forEach(li => {
            li.addEventListener('click', (e) => {
                e.preventDefault();
                const link = li.querySelector('a');
                if (!link) return;
                const href = link.getAttribute('href') || '';
                const tabContent = $(href, container);
                tabs.filter(t => t !== li).forEach(t => removeClass(t, 'active'));
                addClass(li, 'active');
                history.replaceState(null, '', href);
                if (tabContent) tabContent.style.display = '';
                $$('.tab_content', container)
                    .filter(c => c !== tabContent)
                    .forEach(c => (c.style.display = 'none'));
            });
        });
    });

    const page_anchor = window.location.hash;
    if (typeof page_anchor !== 'undefined' && page_anchor !== '') {
        const tabLink = $(`.tabs_container .tabs li a[href='${page_anchor}']`);
        if (tabLink) {
            // Prevent the browser from jumping to the anchor position on load
            const oldScrollRestoration = history.scrollRestoration;
            try { history.scrollRestoration = 'manual'; } catch {}
            // Reset scroll to top without animation
            window.scrollTo(0, 0);
            // Activate the tab without causing a jump
            tabLink.closest('li')?.dispatchEvent(new Event('click', {bubbles: true}));
            // Restore previous scrollRestoration if possible
            try { history.scrollRestoration = oldScrollRestoration; } catch {}
        }
    }

    /*** collapsable panels ***/
    on(document, 'click', '.collapsable > h4:first-child', (e, h4) => {
        const wrap = h4.closest('.collapsable');
        if (wrap) toggleClass(wrap, 'open');
    });

    /*** accordion (details) ***/ 
    $$('details').forEach((det) => {
        // hide inner if not open
        const inner = det.querySelector('.details');
		if(inner) {

			if (!det.hasAttribute('open')) inner.style.display = 'none';

			det.addEventListener('click', (e) => {
				const target = e.target;
				if (!(target instanceof Element)) return;
			   
				// prevent toggling when clicking links
				if (target.matches('a[href]') || target.closest('a[href]')) {
					return; // allow default
				}

				const summary = target.closest('summary');			
				if (!summary) {
					return;	// allow default
				}
				
				const clickedDetails = summary.closest('details');
				if(clickedDetails !== det) {
					return;	// allow default
				}				
				
				e.preventDefault();
				e.stopPropagation();
				
				const detailsEl = det.querySelector(':scope > .details');
				
				if (det.hasAttribute('open')) {
					if (detailsEl) slideUp(detailsEl, 200, () => det.removeAttribute('open'));
				} else {
					det.setAttribute('open', '');
					if (detailsEl) slideDown(detailsEl, 200);
				}
			});
		}
    });

    /*** form errors ***/
    $$('input.error,select.error,textarea.error').forEach((field) => {
        const id = field.getAttribute('id');
        if (id) {
            const label = document.querySelector(`label[for="${id}"]`);
            if (label) addClass(label, 'error');
        }

        const msg = field.getAttribute('data-error');
        if (msg) {
            let insertAfter;
            const crc = field.closest('.checkbox_radio_container');
            if (crc) {
                insertAfter = crc.querySelector('label:last-child, input:last-child') || field;
            } else {
                insertAfter = field;
            }
            if (!insertAfter.nextElementSibling || !insertAfter.nextElementSibling.classList.contains('form_error_message')) {
                insertAfter.insertAdjacentHTML('afterend', `<span class="form_error_message"><span>${msg}</span></span>`);
            }
        }
    });

    /*** pagination ***/
    $$('nav.pagination').forEach((nav) => {
        const ul = nav.querySelector('ul');
        if (!ul) return;

        if (nav.querySelector('li.jump_to')) {
            const lastNonNext = Array.from(nav.querySelectorAll('li'))
                .filter(li => !li.classList.contains('next'))
                .pop();
            const number_of_pages = parseInt(lastNonNext?.querySelector('a')?.textContent || '0', 10) || 0;
            const jumpHTML = `<div class="jump_to_page">
          <input type="number" min="1" max="${number_of_pages}" name="page" placeholder="Page No.">
          <button class="go">Go</button>
          <button class="close_button"></button>
        </div>`;
            nav.insertAdjacentHTML('beforeend', jumpHTML);
        }

        if (ul.scrollWidth > Math.ceil(ul.clientWidth)) {
            const activeLi = ul.querySelector('li.active');
            if (activeLi) {
                const scrollLeftPosition = (activeLi.offsetLeft - (activeLi.clientWidth / 2)) - (ul.clientWidth / 2);
                ul.scrollLeft = Math.max(0, scrollLeftPosition);
            }
        }
    });

    on(document, 'click', '.jump_to > a', (e, a) => {
        const pagination = a.closest('nav.pagination');
        const panel = pagination?.querySelector('.jump_to_page');
        if (!panel) return;
        addClass(panel, 'visible');
        const input = panel.querySelector('input[name="page"]');
        input?.focus();

        const rect = pagination.getBoundingClientRect();
        const targetTop = window.pageYOffset + rect.top - (window.innerHeight / 2) + (pagination.offsetHeight / 2);
        window.scrollTo({top: targetTop, behavior: 'smooth'});
    });

    on(document, 'click', '.jump_to_page .close_button', (e, btn) => {
        const panel = btn.closest('.jump_to_page');
        if (panel) removeClass(panel, 'visible');
    });

    on(document, 'click', '.jump_to_page .go', (e, goBtn) => {
        e.preventDefault();
        const pagination = goBtn.closest('nav.pagination');
        const input = goBtn.previousElementSibling;
        const url_format = pagination?.getAttribute('data-url-format') || '';
        const page_number = parseInt(input?.value || '0', 10);
        if (page_number > 0 && url_format) {
            const page_url = url_format.replace('[number]', String(page_number));
            window.location.href = page_url;
        }
    });

    on(document, 'change', 'select.sort_search', e => {
        let searchParams = new URLSearchParams(window.location.search);
        let order = e.target.value;

        if (order.trim().length === 0) {
            searchParams.delete("order");
        } else {
            searchParams.set("order", e.target.value);
        }

        window.location.search = searchParams.toString();
    })

}); // DOMContentLoaded

/* ====== Global functions (no jQuery) ====== */
function hideModal(id = null) {
    // Prefer new modal system (#modals_container with data-modal-id)
    const container = document.getElementById('modals_container');
    if (container) {
        let toClose;
        if (id) {
            toClose = container.querySelector(`.modal[data-modal-id="${id}"]`);
        } else {
            const visibles = Array.from(container.querySelectorAll('.modal.visible'));
            toClose = visibles.pop();
        }
        if (toClose) {
            toClose.classList.remove('visible');
            toClose.dispatchEvent(new Event('hide'));
            document.documentElement.classList.remove('noscroll');
            return;
        }
    }

    // Legacy fallback (fade out .modal elements)
    const html = document.documentElement;
    removeClass(html, 'noscroll');
    $$('.modal').forEach((modal) => {
        fadeOut(modal, 200, function () {
            const isDynamic = this.matches('[data-name="dynamic_modal"]');
            if (isDynamic) this.innerHTML = '';
        });
    });
}

function removeInvalidCharactersFromNumberPlateInput(input) {
    input.value = (input.value || '').replace(/[^A-Za-z0-9 ]/g, '');
}

function showDynamicModal(content, title, dynamic_modal_type = '') {
    // Prefer new dynamic modal structure if present
    const dynamicModal = document.querySelector('#modals_container .modal[data-modal-id="dynamic"]');
    if (dynamicModal)
    {
        const titleElement = $('h4', dynamicModal);
        if (titleElement) titleElement.innerHTML = (title || 'Message');
        const modalBody = $('.modal_body', dynamicModal);
        if (modalBody) modalBody.innerHTML = content;
        showModal(dynamicModal.getAttribute('data-name'));
        return true;
    }

    // Legacy fallback
    const modal = document.querySelector('.modal[data-name="dynamic_modal"]');
    if (!modal) return;
    modal.setAttribute('data-dynamic-modal-type', dynamic_modal_type);
    modal.innerHTML = content;
    showModal(modal.getAttribute('data-name'));
}

function showModal(name) {
    // Prefer new modal system: #modals_container with data-modal-id
    // const newModal = document.querySelector(`#modals_container .modal[data-modal-id="${name}"]`);
    // if (newModal) {
    //     newModal.classList.add('visible');
    //     newModal.dispatchEvent(new Event('show'));
    //     $('[data-focus-on-show-modal]', newModal)?.focus?.();
    //     document.documentElement.classList.add('noscroll');
    //     return;
    // }

    // Legacy fallback (data-name)
    $$('.modal').forEach(m => {
        if (m.getAttribute('data-name') !== name) m.style.display = 'none';
    });

    const modal = document.querySelector(`.modal[data-name="${name}"]`);

    if (!modal) return;

    if (modal.classList.contains('with_close_button') && !modal.querySelector('button.close_button')) {
        modal.insertAdjacentHTML('afterbegin', '<button class="close_button">×</button>');
    }
    if (!modal.querySelector('.modal_content')) {
        const content = document.createElement('div');
        content.className = 'modal_outer';
        content.innerHTML = '<div class="modal_inner"><div class="modal_content"></div></div>';
        // move all existing children into modal_content
        content.querySelector(".modal_content").innerHTML = modal.innerHTML;
        modal.appendChild(content);
    }
    addClass(document.documentElement, 'noscroll');
    fadeIn(modal, 200);
}

function smoothScrollToObject(object, speed = 350, ignore_header = false) {
    let scrollOffset = 0;
    const header = document.getElementById('page_header');
    if (!ignore_header && header) {
        scrollOffset = header.offsetHeight;
    }
    const styles = getComputedStyle(object);
    const marginTop = parseInt(styles.marginTop || '0', 10) || 0;
    const borderTop = parseInt(styles.borderTopWidth || '0', 10) || 0;

    const top = getOffsetTop(object) - scrollOffset - marginTop - borderTop;
    window.scrollTo({
        top,
        behavior: speed <= 0 ? 'auto' : 'smooth'
    });
}

/* ====== Lazy-loaded <video> (loading="lazy" isn't valid on <video>, so this defers the fetch manually) ====== */
document.addEventListener('DOMContentLoaded', function () {
    const lazyVideos = $$('video[data-lazy="true"]');
    if (!lazyVideos.length) return;

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const video = entry.target;
            const source = video.querySelector('source[data-src]');
            if (source) {
                source.src = source.dataset.src;
                delete source.dataset.src;
                video.load();
                if (video.dataset.autoplayIntent === 'true') {
                    video.play().catch(() => {});
                }
            }
            obs.unobserve(video);
        });
    }, { rootMargin: '200px 0px' });

    lazyVideos.forEach((video) => observer.observe(video));
});
